"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

const links = [
  { name: "Case Studies", path: "/case-studies" },
  { name: "Testimonials", path: "/testimonials" },
  { name: "Services", path: "/services" },
  { name: "Pitch Deck", path: "/pitch" },
  { name: "About", path: "/about" },
];

export function Navigation() {
  const pathname = usePathname();

  const isAdmin = pathname.startsWith("/admin");
  const isStatus = pathname.startsWith("/status");
  const isClient = pathname.startsWith("/client");
  const isPrint = pathname.includes("/print");
  const isInvoice = pathname.startsWith("/invoice");

  if (isAdmin || isClient || isPrint || isInvoice) return null;

  return (
    <header className="fixed top-0 left-0 right-0 z-[100] p-6 md:p-8 hidden md:flex justify-between items-center pointer-events-none mix-blend-difference text-white transition-all duration-300 backdrop-blur-md bg-black/5">
      <Link href="/" className="pointer-events-auto hover:opacity-80 transition-opacity flex items-center py-2">
        <img src="/logo/Primary_Light_Color.svg" alt="DOTSLASHLAB" className="h-6 md:h-8 w-auto dark:hidden scale-[1.5] md:scale-[2] origin-left" />
        <img src="/logo/Primary_Dark_Color.svg" alt="DOTSLASHLAB" className="h-6 md:h-8 w-auto hidden dark:block scale-[1.5] md:scale-[2] origin-left" />
      </Link>
      
      {!isStatus && (
        <nav className="flex gap-4 md:gap-12 pointer-events-auto items-center">
          {links.map((link) => (
            <Link
              key={link.path}
              href={link.path}
              className={cn(
                "font-sans text-[10px] md:text-xs uppercase tracking-[0.4em] transition-all hover:text-primary relative group",
                pathname.startsWith(link.path) ? "text-primary" : "text-white/60 hover:text-white"
              )}
            >
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-primary group-hover:w-full transition-all duration-500" />
            </Link>
          ))}
          
          <Link 
            href="/contact" 
            className="px-6 py-3 bg-white text-black font-sans text-[10px] uppercase tracking-widest rounded-full hover:scale-105 transition-all active:scale-95 pointer-events-auto"
          >
            Start a Project
          </Link>
        </nav>
      )}
    </header>
  );
}
